import "./LogoDesignPage.scss";
import React from "react";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import TextBlock from "../../components/TextBlock/TextBlock";
import ServiceContact from "../../components/ServiceContact/ServiceContact";
import milestoneLogo from "../../assets/images/milestone-logo-yeti-cropped.png";
import MiniCaseStudy from "../../components/MiniCaseStudy/MiniCaseStudy";

import LogoGrid from "../../components/LogoGrid/LogoGrid";
import logo1 from "../../assets/images/logo-design_1.png";
import logo2 from "../../assets/images/logo-design_2.png";
import logo3 from "../../assets/images/logo-design_3.png";
import logo4 from "../../assets/images/logo-design_4.png";
import logo5 from "../../assets/images/logo-design_5.png";
import logo6 from "../../assets/images/logo-design_6.png";
import logo7 from "../../assets/images/logo-design_7.png";

const logoSamples = [logo1, logo2, logo3, logo4, logo5, logo6, logo7];

const LogoDesignPage = () => {
    return (
      <div className="logo-design-page">
        <ServiceSection
          subtitle="SERVICES"
          title="Logo Design"
          description="Get a premium, vector-based logo designed to elevate your brand across digital platforms and marketing materials."
          buttonLabel="Get started now"
        link="/contact"
        />
        <TextBlock
        title="Time for a Brand Refresh"
        description="Your logo should grow with your business. If it feels outdated or misaligned, it's time for a modern update."
        />
         <TextBlock
        title="Launching Something New? Start with a Logo"
        description="A strong logo builds credibility and sets the tone for your entire brand—right from the start."
        />
         <TextBlock
        title="Celebrate Your Milestone with a Custom Anniversary Logo"
        description="Showcase your business's longevity with a fresh design that honors where you’ve been—and where you're going."
        />
       <LogoGrid logos={logoSamples} />
       <ServiceContact
      heading="Your Logo Is Your First Impression—Make It Count"
      subheading="Let’s get your logo started today — contact me for a free design consultation."
      />
       <MiniCaseStudy
        title="Milestone Logo"
        description={
          <>
            I designed a custom 40th-anniversary logo for Aquaman Irrigation, incorporating colors and elements from their existing brand identity. This highly personalized logo seamlessly connects with their history while celebrating their milestone.
              <br /> <br />
              The logo works beautifully across various platforms—whether it’s featured in advertisements, on company websites, social media platforms,  business cards, or other marketing materials.
              <br /> <br />
              Show off your milestone in style—on a YETI!
           </>
        }
        image={milestoneLogo}
      />
      </div>
    );
  };
  
  export default LogoDesignPage;